module.exports = __webpack_public_path__ + "static/media/demo1.66d11181.jpg";